skrilla.directive('entityEventLogs',function() {
    return {
        templateUrl: 'directives/entityEventLogs/entityEventLogs.html',
        scope: {
            type: "=",
            id: "=",
            key: "="
        },
        controller: function($scope, searchService, paginationService, queryService, modalService, cacheService){

            $scope.reset = function () {
                $scope.query = {
                    limit: 20
                };
            };
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getLogs, $scope.key);
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }

            var getLogs = function () {
                const typePath = $scope.type ? `/${$scope.type}` : '';
                return searchService.get(`entityEventLogs${typePath}/${$scope.id}${queryService.getQueryString($scope.query, $scope.key)}`).then(function (response) {
                    $scope.logs = response.data.result;
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            $scope.open = function(log){
                cacheService.registerObject("entityEventLog", log);
                modalService.openModal("/directives/entityEventLogs/entityEventLogsModal.html", true, "lg", true, true, true);
            }

        }
    };
});
